import { render, staticRenderFns } from "./ExibirConvenio.vue?vue&type=template&id=ee0220a6&scoped=true&"
import script from "./ExibirConvenio.vue?vue&type=script&lang=js&"
export * from "./ExibirConvenio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee0220a6",
  null
  
)

export default component.exports